<template>
  <div>
    <v-dialog v-model="show" persistent max-width="800px">
      <v-card class="dialog">
        <v-toolbar class="grey lighten-3">
          <span class="headline primary--text">
            Descargo de responsabilidad
          </span>
          <v-spacer />
          <v-btn icon @click="closeDialog()">
            <v-icon color="primary"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-container style="max-height: 50vh; overflow-y: auto">
          <v-row>
            <v-col>
              <p class="font-weight-light">
                Este Sistema informático y todos los datos son de la Comunidad
                Autónoma de Andalucía y únicamente están disponibles para fines
                autorizados por usuarios autorizados. El empleo para cualquier
                otro fin puede causar acciones administrativas/disciplinarias o
                el procesamiento criminal contra el usuario. Su uso está sujeto
                a pruebas de seguridad y supervisión. El usuario no debería
                tener ninguna expectativa de privacidad excepto las
                proporcionadas según las leyes de privacidad aplicables.
              </p>
            </v-col>
          </v-row>
        </v-container>
        <v-toolbar class="grey lighten-3 d-flex justify-end">
          <v-btn
            color="primary"
            @click="
              remember = true;
              closeDialog();
            "
          >
            Aceptar - No volver a mostrar
          </v-btn>
        </v-toolbar>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      dialog: true,
      remember: false,
    };
  },
  methods: {
    closeDialog() {
      if (this.remember) {
        window.localStorage.setItem("DisclaimerDialog", true);
      }
      this.$emit("close");
    },
  },
};
</script>
